import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import * as React from 'react';

import { UitkDialog, UitkDialogContent } from 'uitk-react-dialog';
import { UitkHeading } from 'uitk-react-text';

export interface FlexDocumentDialogProps {
  url: string;
  headerText: string;
}

export const FlexDocumentDialog: React.FunctionComponent<FlexDocumentDialogProps> = ({ url, headerText }) => {
  return (
    <DialogRoute id="flex-document-dialog">
      <Layer id="dialog">
        <UitkDialog className="FlexDocument__dialog">
          <UitkDialogContent key="flexDialogContent1" className="FlexDocumentContent__dialog">
            <UitkHeading tag="h2" size={3}>
              {headerText}
            </UitkHeading>
            <iframe src={url} />
          </UitkDialogContent>
        </UitkDialog>
      </Layer>
    </DialogRoute>
  );
};
